module.exports = __webpack_public_path__ + "images/foundations.jpg?v=7381a2e1b667a353601a8c3274baec5f";